import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox, ListItemText } from "@material-ui/core";

const TagValueItem = ({ item, onChange, isChecked, tagId }) => {
	const itemArg = {
		tag: tagId,
		value: item.value
	};
	const isItemChecked = isChecked(itemArg) || false;
	const handleChange = () => {
		onChange(itemArg);
	};
	const checkedClass = isItemChecked ? "bg-green-100" : "";
	return (
		<div className={`rounded py-2 px-4 mb-1 block ${checkedClass}`}>
			<FormControlLabel
				key={item.value}
				control={
					<Checkbox
						checked={isItemChecked}
						onChange={handleChange}
						value={item.value}
						color="primary"
					/>
				}
				label={item.value}
			/>
			<ListItemText
				secondary={`Recursos: ${item.resourcesCount} Estadísticos: ${item.availableStatsCount}`}
			/>
		</div>
	);
};

export default TagValueItem;



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-values-selector/tag-value-item.js